import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import PowerIcon from '@material-ui/icons/PowerSettingsNew'
import FaqIcon from '@material-ui/icons/HelpOutline'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import { useSelector, useDispatch } from 'react-redux'
import { detachDelightedSurvey, getInitialsFromName } from '../../utils'
import { withRouter } from 'react-router-dom'
import Fade from '@material-ui/core/Fade'
import {
    LOCALE_DISPLAY_OPTIONS,
    LOCALE_CODES,
    SETTINGS_DROPDOWN_URLS
} from './constants'
import {
    logout as logoutUser,
    setLocale,
    saveLocaleRequest,
    reloadUser
} from './actions'
import { IconButton, Picker } from './components/common'
import { SettingsSectionGroupItem } from 'web/src/app/root/components/common/settings-section-group/settings-section-group-item'
import AccountIcon from 'web/src/assets/svg/account-icon.svg'
import NotificationsIcon from 'web/src/assets/svg/notifications-icon.svg'
import SimCardIcon from 'web/src/assets/svg/sim-card.svg'
import ManualIcon from 'web/src/assets/svg/manual-icon.svg'
import ChatIcon from 'web/src/assets/svg/chat-icon.svg'
import ReportBugIcon from 'web/src/assets/svg/report-bug-icon.svg'
import RoadmapIcon from 'web/src/assets/svg/roadmap-icon.svg'
import VoteIcon from 'web/src/assets/svg/vote-icon.svg'
import TermsOfSevicesIcon from 'web/src/assets/svg/terms-of-services-icon.svg'
import PrivacyPolicyIcon from 'web/src/assets/svg/privacy-policy-icon.svg'
import { Typography } from '@material-ui/core'
import { UserPermissions } from 'web/src/services/permissions'
import { createPortalSession } from './api/stripe-api'
import { useMutation } from 'react-query'
import AccountBalanceWalletOutlined from '@material-ui/icons/AccountBalanceWalletOutlined'
import { enqueueSnackbar } from './actions'
import { ReceiptEuroIcon, ReceiptTextIcon } from 'lucide-react'

const useStyles = makeStyles(theme => ({
    accountMenuWrapper: {
        position: 'relative'
    },
    menu: {
        position: 'absolute',
        top: 31,
        left: -268,
        width: 290,
        padding: 0,
        backgroundColor: theme.background,
        border: theme.border,
        borderRadius: theme.borderRadius,
        fontFamily: theme.fontFamily,
        fontSize: 13,
        fontWeight: 'bold',
        color: theme.textPrimary,
        zIndex: 9999
    },
    accountMenuLink: {
        cursor: 'pointer'
    },
    headerItems: {
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        borderBottom: theme.border
    },
    supplementaryItems: {
        padding: 20
    },
    userLogo: {
        fontFamily: theme.fontFamily,
        backgroundColor: theme.background,
        border: theme.border,
        textAlign: 'center',
        color: theme.textSecondary,
        width: 44,
        height: 44,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 25,
        fontSize: 14,
        '&:hover': {
            border: `2px solid ${theme.primary}`,
            color: theme.primary,
            fontWeight: 'bold'
        }
    },
    userLogoMenu: {
        fontFamily: theme.fontFamily,
        backgroundColor: theme.background,
        border: theme.border,
        textAlign: 'center',
        color: theme.textSecondary,
        width: 72,
        height: 72,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 40,
        fontSize: 20,
        marginBottom: 15
    },
    emailMenu: {
        color: theme.textSecondary,
        marginTop: 5
    },
    langSection: {
        display: 'flex',
        padding: 20,
        borderBottom: theme.border,
        justifyContent: 'space-between',
        alignItems: 'center',
        color: theme.textSecondary
    },
    settingsSectionGroupTitle: {
        padding: '10px 0',
        fontWeight: 'bold',
        fontSize: 15
    }
}))

function AccountDropdown(props) {
    const { user, localeCode, locale, i } = useSelector(state => state.main)
    const classes = useStyles()
    const dispatch = useDispatch()

    const [isMenuOpened, setIsMenuOpened] = useState(false)

    const logout = () => {
        if (i && i.superAdminId) {
            dispatch(reloadUser(true))
        } else {
            dispatch(logoutUser())
            detachDelightedSurvey()
            props.history.push('/')
        }
    }

    const onSettingsClick = () => {
        setIsMenuOpened(false)
        props.history.push('/profile')
    }

    const onFaqClick = () => {
        setIsMenuOpened(false)
        localeCode === LOCALE_CODES.de
            ? props.history.push('/faq')
            : props.history.push('/')
    }

    const onLanguageSelect = localeCode => {
        dispatch(setLocale(localeCode))
        dispatch(saveLocaleRequest(localeCode))
    }

    const onSimCardsClick = () => {
        setIsMenuOpened(false)
        props.history.push('/sim-cards')
    }

    const onBillingClick = () => {
        setIsMenuOpened(false)
        props.history.push('/billing')
    }

    const onMonetisationClick = () => {
        setIsMenuOpened(false)
        props.history.push('/monetisation')
    }

    /* const portalMutation = useMutation(createPortalSession, {
        onSuccess: data => {
            window.location.href = data.url
        },
        onError: error => {
            dispatch(
                enqueueSnackbar({
                    message: locale.settings.portalError,
                    options: {
                        variant: 'error'
                    }
                })
            )
        }
    })

    const onPortalClick = () => {
        portalMutation.mutate()
    } */

    return (
        <div className={classes.accountMenuWrapper}>
            <ClickAwayListener onClickAway={setIsMenuOpened.bind(this, false)}>
                <div>
                    <div
                        onClick={setIsMenuOpened.bind(this, !isMenuOpened)}
                        className={classes.accountMenuLink}
                    >
                        <div className={classes.userLogo}>
                            {getInitialsFromName(user.name)}
                        </div>
                    </div>
                    <Fade in={isMenuOpened} timeout={500}>
                        <div className={classes.menu}>
                            <div className={classes.headerItems}>
                                <div className={classes.userLogoMenu}>
                                    {getInitialsFromName(user.name)}
                                </div>
                                <div className={classes.emailMenu}>
                                    {user.name}
                                </div>
                                <div className={classes.emailMenu}>
                                    {user.email}
                                </div>
                                <div className={classes.emailMenu}>
                                    {user.original_customer_name}
                                </div>
                            </div>
                            <div className={classes.langSection}>
                                <div>{locale.settings.language}:</div>
                                <Picker
                                    disablePortal
                                    onChange={onLanguageSelect}
                                    value={localeCode}
                                    options={LOCALE_DISPLAY_OPTIONS}
                                />
                            </div>
                            <div className={classes.supplementaryItems}>
                                <div>
                                    <Typography
                                        className={
                                            classes.settingsSectionGroupTitle
                                        }
                                    >
                                        {locale.settings.settings}
                                    </Typography>
                                    <SettingsSectionGroupItem
                                        name={locale.common.account}
                                        icon={AccountIcon}
                                        onClick={onSettingsClick}
                                    />
                                    <SettingsSectionGroupItem
                                        name={
                                            locale.settings.notificationsEvents
                                        }
                                        icon={NotificationsIcon}
                                        onClick={onSettingsClick}
                                    />
                                    {UserPermissions.device().update && (
                                        <SettingsSectionGroupItem
                                            name={locale.settings.simCards}
                                            icon={SimCardIcon}
                                            onClick={onSimCardsClick}
                                        />
                                    )}
                                    {/* {UserPermissions.isDemoBillingAccess() && (
                                        <SettingsSectionGroupItem
                                            name={locale.billing.billing}
                                            IconComponent={props => (
                                                <ReceiptTextIcon
                                                    {...props}
                                                    size={18}
                                                />
                                            )}
                                            onClick={onBillingClick}
                                        />
                                    )} */}
                                    {UserPermissions.isAdmin() &&
                                        !UserPermissions.isTraplinkedAdmin() && (
                                            <SettingsSectionGroupItem
                                                name={locale.billing.billing}
                                                IconComponent={props => (
                                                    <ReceiptTextIcon
                                                        {...props}
                                                        size={18}
                                                    />
                                                )}
                                                onClick={onBillingClick}
                                            />
                                        )}
                                    {UserPermissions.isTraplinkedAdmin() && (
                                        <SettingsSectionGroupItem
                                            name={locale.billing.monetisation}
                                            IconComponent={props => (
                                                <ReceiptEuroIcon
                                                    {...props}
                                                    size={18}
                                                />
                                            )}
                                            onClick={onMonetisationClick}
                                        />
                                    )}
                                    {/* {UserPermissions.isAllOriginalGranted() && (
                                        <SettingsSectionGroupItem
                                            name={locale.settings.billingPortal}
                                            IconComponent={props => (
                                                <AccountBalanceWalletOutlined
                                                    {...props}
                                                    fontSize="small"
                                                />
                                            )}
                                            onClick={onPortalClick}
                                        />
                                    )} */}
                                </div>
                                <div>
                                    <Typography
                                        className={
                                            classes.settingsSectionGroupTitle
                                        }
                                    >
                                        {locale.common.support}
                                    </Typography>
                                    <SettingsSectionGroupItem
                                        name={locale.common.supportChat}
                                        icon={ChatIcon}
                                        url={
                                            localeCode === LOCALE_CODES.de
                                                ? SETTINGS_DROPDOWN_URLS.de.chat
                                                : SETTINGS_DROPDOWN_URLS.common
                                                      .chat
                                        }
                                    />
                                    <SettingsSectionGroupItem
                                        name={locale.common.manual}
                                        icon={ManualIcon}
                                        url={
                                            localeCode === LOCALE_CODES.de
                                                ? SETTINGS_DROPDOWN_URLS.de
                                                      .scribe
                                                : SETTINGS_DROPDOWN_URLS.common
                                                      .scribe
                                        }
                                    />
                                    <SettingsSectionGroupItem
                                        name={locale.settings.reportBug}
                                        icon={ReportBugIcon}
                                        url={
                                            SETTINGS_DROPDOWN_URLS.common
                                                .bugReport
                                        }
                                    />
                                    <SettingsSectionGroupItem
                                        name={locale.settings.viewOurRoadmap}
                                        icon={RoadmapIcon}
                                        url={
                                            SETTINGS_DROPDOWN_URLS.common
                                                .roadmap
                                        }
                                    />
                                    <SettingsSectionGroupItem
                                        name={locale.settings.voteOnNewFeatures}
                                        icon={VoteIcon}
                                        url={
                                            SETTINGS_DROPDOWN_URLS.common
                                                .featureIdeas
                                        }
                                    />
                                </div>
                                <div>
                                    <Typography
                                        className={
                                            classes.settingsSectionGroupTitle
                                        }
                                    >
                                        {locale.common.about}
                                    </Typography>
                                    <SettingsSectionGroupItem
                                        name={locale.settings.termsOfService}
                                        icon={TermsOfSevicesIcon}
                                        url={
                                            localeCode === LOCALE_CODES.de
                                                ? SETTINGS_DROPDOWN_URLS.de
                                                      .terms
                                                : SETTINGS_DROPDOWN_URLS.common
                                                      .terms
                                        }
                                    />
                                    <SettingsSectionGroupItem
                                        name={locale.settings.privacyPolicy}
                                        icon={PrivacyPolicyIcon}
                                        url={
                                            localeCode === LOCALE_CODES.de
                                                ? SETTINGS_DROPDOWN_URLS.de
                                                      .privacy
                                                : SETTINGS_DROPDOWN_URLS.common
                                                      .privacy
                                        }
                                    />
                                </div>

                                <div>
                                    <Typography
                                        className={
                                            classes.settingsSectionGroupTitle
                                        }
                                    >
                                        {locale.settings.logout}
                                    </Typography>
                                    <SettingsSectionGroupItem
                                        name={locale.settings.logout}
                                        IconComponent={PowerIcon}
                                        onClick={logout}
                                    />
                                    {localeCode === LOCALE_CODES.de && (
                                        <SettingsSectionGroupItem
                                            name={locale.settings.faq}
                                            IconComponent={FaqIcon}
                                            onClick={onFaqClick}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </Fade>
                </div>
            </ClickAwayListener>
        </div>
    )
}

export default withRouter(AccountDropdown)
